import styled from '@emotion/styled'
import React from 'react'
import BreakPoints from '../../styles/breakPoints'
import ColumnH1 from '../atoms/columnH1'
import ColumnBtnCard from '../atoms/columnBtnCard'
import useRouteParam from '../../hooks/useRouteParam'

const Wrapper = styled.article`
  section {
    display: flex;
    flex-wrap: wrap;
    justify-content: start;

    span {
      display: none;
    }
  }

  ${BreakPoints.large} {
    margin-bottom: 10px;
  }
`

/**
 * 関連記事カードセット
 * TODO 川上申し送り事項：記事詳細下部に表示されるコンポーネントです。
 * ここでは、表示している記事に関連した他の記事3件が表示される予定です
 * @constructor
 */
const ColumnRelationCards0045 = () => {
  const routeParam = useRouteParam('/column/details/C0029/')
  return (
    <Wrapper>
      <ColumnH1 label="関連コラム" />
      <section>
        <ColumnBtnCard
          href={routeParam}
          imgId="c0029.jpg"
          label="中小企業も対象？時間外労働の上限時間や割増賃金率の引き上げ"
          date="2022.04.15"
        />
      </section>
    </Wrapper>
  )
}

export default ColumnRelationCards0045
